import React, { useState, useEffect } from 'react';
import { Text, Button, BackButton } from 'ui';
import { updateCampaign, useCampaign, useAuth } from 'api';
import { useParams, useHistory } from 'react-router-dom';
import {DateInput} from 'ui';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";


export default function CampaignTimeframe(props) {
  
  const { campaignId } = useParams();
  const auth = useAuth();
  const campaign = useCampaign(auth ? auth.user.companyId : null, campaignId);
  const history = useHistory();
  
  const [start, setStart] = useState(new Date());
  const [end, setEnd] = useState(new Date());
  const [days, setDays] = useState({});
  useEffect(() => {
    if(!campaign) {
      return;
    }
    setStart(moment(campaign.start).toDate() || new Date());
    setEnd(moment(campaign.end).toDate() || new Date());
    setDays(campaign.days || {});
  }, [campaign]);
  
  function save() {
    updateCampaign(auth.user.companyId, campaignId, {
      start: moment(start).valueOf(), 
      end: moment(end).valueOf(),
      days
    });
    history.push('view');
  }
  
  function skip() {
    updateCampaign(auth.user.companyId, campaignId, {
      allTime: true,
    });
    history.push('view');
  }
  
  if(!campaign) {
    return null;
  }
  
  return (
    <div>
      <div style={{display:'flex', flexDirection:'row', alignItems:'center', backgroundColor:'white', padding:"24px"}}>
        <BackButton onClick={() => props.history.goBack()} style={{marginRight:16}}/>
        <Text large light style={{flex:1}}>Build a Campaign</Text>
      </div>
      <div style={{padding:"0 24px 40px 24px"}}>
        <div style={{height:80, paddingBottom:40, display:'flex', flexDirection:'row', alignItems:'center'}}>
          <Text huge color="#00b2a8" style={{flex:1}}>{campaign.name}</Text>
        </div>
        
        <div style={{maxWidth:600, margin:'0 auto'}}>
          <Text large light block style={{marginBottom:16}}>Campaign Timeframe</Text>
          
          <div style={{display:'flex', flexDirection:'row', marginBottom:24}}>
            
            <DateInput
              label="Start Date"
              value={start}
              onChange={setStart}
              style={{marginRight:16}}
            />
          
            <DateInput
              label="End Date"
              value={end}
              onChange={setEnd}
            />
            
          </div>
          
          {/*
          <div style={{marginBottom:24}}>
            <Text bold small block style={{marginBottom:8}}>Days of the Week</Text>
            <div style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
              {["S","M","T","W","T","F","S"].map((d, i) => 
                <Button 
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 32,
                    height: 32,
                    padding: 0,
                    backgroundColor: !!days[i] ? "#00b2a8" : "#b3b3b3",
                    marginRight: 16,
                    borderRadius: 16,
                  }}
                  onClick={() => setDays({...days, [i]:!days[i]})}
                  key={i}>
                  <Text white bold>{d}</Text>
                </Button>
              )}
              
              
              <Checkbox color="#00b2a8" style={{margin:'0 32px'}}>
                <Text small bold>Repeat</Text>
              </Checkbox>
              
              <Button white small backgroundColor="#00b2a8" label="Add to Calendar"/>
              
            </div>
          </div>
          */}
          
          <div>
            <Button onClick={save} label="NEXT" small white backgroundColor="#243746"/>
            <Button onClick={skip} label="Skip" small/>
          </div>
        </div>
      </div>
    </div>
  );
}